import Apiservice from '@/core/services/api.service';
import { API_URL } from '@/common/config.js'
const apiService = Apiservice;


export default class GradeLevelService {

      #api = null;

      constructor() {
            this.#api = `${API_URL}user/kiosk/grades`;

      }
      all() {
            let url = `${this.#api}`;
            return apiService.get(url);
      }

      getByProgram(programId) {
            let url = `${this.#api}/${programId}/by-programs`;
            return apiService.get(url);
      }

}
